/* @flow */
import { Map } from 'immutable';
import { PushEvents as PUSH_CONSTANTS } from 'pusher/PusherConstants';

export type PhoneCallStatus =
  | 'started'
  | 'connecting'
  | 'in_progress'
  | 'completed'
  | 'no_answer'
  | 'failed'
  | 'busy'
  | 'canceled'
  | 'caller_unreachable'
  | 'unknown';

export type PhoneCall = {|
  uuid: string,
  caller_uuid: string,
  callee_uuid: string,
  status: PhoneCallStatus,
  duration: number,
  received_at: Date,
|};

export type State = Map<string, PhoneCall>;
export const initialState: State = new Map();

export default function reducer(state: State = initialState, action: *): State {
  switch (action.type) {
    case PUSH_CONSTANTS.CHANGESET_UPDATE_PHONE_CALL: {
      return action.changes.reduce(
        (newState, change) =>
          newState.set(change.uuid, {
            received_at: new Date(),
            ...change.content,
          }),
        state
      );
    }
    default:
      return state;
  }
}
